import React from "react";
import { Box, Button, Typography } from "@mui/material";

interface Props {
  onLabEdit: () => void;
  onGroupEdit: () => void;
}

function LabMasterData({ onLabEdit, onGroupEdit }: Props): React.ReactNode {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <Button onClick={onLabEdit} variant="outlined">
        <Typography fontWeight="700" textTransform="none" maxWidth={180} color="#555">
          Create or Edit Lab Test
        </Typography>
      </Button>
      <Button onClick={onGroupEdit} variant="outlined">
        <Typography fontWeight="700" textTransform="none" maxWidth={180} color="#555">
          Create or Edit Test Group
        </Typography>
      </Button>
    </Box>
  );
}

export default LabMasterData;
